import React, { useState } from 'react'
import tw, { styled } from 'twin.macro'
import { Link, graphql, useStaticQuery } from 'gatsby'
import Spinner from '@ui-kit/atoms/spinner'
import {
    useQuery,
    useQueryClient,
    QueryClient,
    QueryClientProvider,
  } from 'react-query'


const queryClient = new QueryClient()

const NetworkStatusPanel = ({ env, ...props }) => {
    const [ tab, setTab ] = useState<string>('mobile')

    return (
        <Style className='content-slice content-slice--network-status-panel' {...props}>
            {/*<ul className="tabs">
                {['mobile', 'broadband'].map((service:string) => (
                    <li key={service}>
                        <button disabled={service === tab} type="button" onClick={() => setTab(service)}>{service}</button>
                    </li>
                ))}
                </ul>*/}
            <QueryClientProvider client={queryClient}>
                <Table activeTab={tab} />
            </QueryClientProvider>
        </Style>
    )
}
export default NetworkStatusPanel


const Table = ({ activeTab: tab }) => {

    const { data, isLoading, isError } = useQuery('network-status', async () => {
        return await fetch(`https://nova-network-status.web.app/network-status.json`).then(async res => await res.json());
    })

    const { broadband } = useStaticQuery(query);

    if(isLoading) {
        return <Spinner label={'Loading'} />
    }

    const generated = new Date(data.generated);

    data.data.broadband = broadband.r.statuses;

    return (
        <div className="network-status__table">
            {['mobile', 'broadband'].map((service:string) => data.data[service].length === 0 ? <p  className={[tab === service ? 'table' : 'hidden', "no-network-status"].join(' ')}>No {service} outages or planned maintenance at this time. <Link to="/help-advice/contact-us">Report an outage</Link>.</p> : (
                <table className={tab === service ? 'table mb-0' : 'hidden'}>
                    <caption>Information is provided as at {new Intl.DateTimeFormat('en-GB', { dateStyle: 'long', timeStyle: 'short' }).format(generated)} and subject to change. While care is taken and the information is provided for your convenience, 2degrees and Nova take no responsibility for the accuracy of this information. 2degrees and Nova accept no responsibility or liability in relation to any information on this webpage.</caption>
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Location &amp; time</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                    {data.data[service].map((row:any) => (
                        <tr>
                            <td>
                                <span data-status={row.status}>{row.status}</span>
                            </td>
                            <td>
                                <h2>{row.location}<span data-status={row.status}>{row.status}</span></h2>
                                {service === 'mobile' ? <p>{row.time}</p> : <p>{new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(row.window.start))}{row.window.end ? ` to ${new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(row.window.end))}` : ''}</p> }
                            </td>
                            {service === 'mobile' ? <td className="network-status__description">{row.description}</td> : <td className="network-status__description" dangerouslySetInnerHTML={{__html: row.description.html }} />}
                        </tr>
                    ))}
                    </tbody>
                </table>
                    ))}
            </div>
    )
}

const query = graphql`
    fragment NetworkStatus on paragraph__network_status {
        title:field_title
        window:field_window {
          end:end_value(locale: "")
          start:value(locale: "")
        }
        status:field_status
        description:field_body {
          html:processed
        }
    }

    query NetWorkStatuses {
        broadband:nodeNetworkStatusPanel(
            relationships: {field_content_status: {name: {eq: "Approved"}}}
        ) {
            r:relationships {
                statuses:field_broadband_statuses {
                    ...NetworkStatus
                }
            }
        }
    }
`


const Style = styled.div`
    ${tw `container mx-auto px-4 my-10 lg:my-24`}

    .tabs {
        ${tw `flex font-semibold gap-2 lg:gap-x-6 text-lg`}

        button {
            ${tw `capitalize transition-colors rounded-xl bg-transparent border border-dashed border-neutral-500 text-black py-4 leading-none px-8 lg:min-w-[220px]`}

            &:not(:disabled):hover {
                ${tw `bg-green border-solid text-white border-green`}
            }

            &:disabled {
                ${tw ` bg-primary border-solid border-primary cursor-default`}
            }
        }

    }

    .network-status__table {
        ${tw `max-w-full overflow-hidden text-base mt-5`}

        .table {
            ${tw `w-full`}
        }

        caption {
            ${tw `caption-bottom text-left text-sm pt-6 text-neutral-500`}
        }

        th {
            ${tw `font-semibold text-neutral-500`}
        }

        td span {
            ${tw `text-sm uppercase text-[var(--nova-blue)] font-semibold`}

            &[data-status="Under Repair"] {
                ${tw `text-[var(--nova-orange)]`}
            }
            &[data-status="Resolved"] {
                ${tw `text-[var(--nova-green)]`}
            }
        }

        td > span {
            ${tw `inline-block`}
        }

        td h2 {
            ${tw `text-base lg:text-lg leading-snug mb-1 font-semibold block`}

            span {
                ${tw `block md:hidden`}
            }
        }

        td p {
            ${tw `text-sm`}
        }

        th:first-child, td:first-child {
            ${tw `hidden md:table-cell`}
        }
    }

    .no-network-status {
        ${tw `text-lg mt-5`}

        a {
            ${tw `underline underline-offset-2 text-primaryDark`}
        }
    }

    .network-status__description {
    }
`